



































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import UserLessons from "@/components/lessons/userLessons.vue";
import { Team, LearnerTeam } from "@/types";
import teamChange from "@/components/teamChangeLearner.vue";
import Practice from "@/views/learner/learnerpractice.vue";
import Recordings from "@/views/learner/learnerrecordings.vue";
import LearnerAccount from "@/views/learner/learneraccount.vue";
import LearnerReviews from "@/views/learner/learnerReviews.vue";
import { Action, Getter } from "vuex-class";
import Parrot from "@/assets/images/parrot/ParrotMicSinging.svg?inline";
import consts from "@/consts";
import { getDomain } from "@/auth";
import { source, refreshAxiosCancelToken } from "@/store/actions";
import amplitude from "amplitude-js";

enum Tabs {
  library = "library",
  account = "account",
  recordings = "recordings",
  practice = "practice",
  review = "review",
  purchase = "purchase",
}

@Component({
  components: {
    teamChange,
    UserLessons,
    Practice,
    Recordings,
    LearnerAccount,
    LearnerReviews,
    Parrot,
  },
})
export default class LearnerView extends Vue {
  private activeTab: string = "";
  private showPurchaseOptions = false;
  private localDoneInitAssessment = false;
  @Action private fetchUserPlan!: () => any;
  @Action private fetchLearnerTeams!: (currentLearnerTeam?: LearnerTeam) => any;

  @Action private setCurrentLearnerTeam?: any;
  @Getter private currentLearnerTeam!: LearnerTeam;

  @Getter private doneInitAssessment?: any;
  @Getter private userPlan?: any;
  @Getter private userPlanLoading?: any;
  @Getter private teams?: Team[];
  @Getter private learnerTeamByID!: (id: number) => LearnerTeam;

  @Action private resetState: any;

  private $amplitude: any;

  private created() {
    const learnerTeam = this.$cookies.get(consts.currentLearnerTeam);
    if (learnerTeam) {
      console.log(learnerTeam.name);

      this.setCurrentLearnerTeam(learnerTeam);
    }
    this.assignInitAssessment();
    this.fetchUserPlan();
    this.fetchLearnerTeams(this.currentLearnerTeam);

    // Setup amplitude
    // source.cancel();
    // let domain = getDomain(window.location.href) as string | undefined;
    // this.$cookies.remove("ORAI_AUTH", "/", domain);
    // this.$cookies.remove(consts.currentLearnerTeam, "/", domain);
    // localStorage.clear();
    // this.resetState();
    // refreshAxiosCancelToken();
    // amplitude.getInstance().init(consts.amplitudeKey, "", {
    //   saveEvents: true,
    //   includeUtm: true,
    //   includeReferrer: true,
    // });
    // this.$amplitude = amplitude.getInstance();
  }

  private onDoneAssessment() {
    this.localDoneInitAssessment = true;
  }

  private changeTeam(teamID: number) {
    let team = this.learnerTeamByID(teamID);
    this.setCurrentLearnerTeam(team);
    let domain = getDomain(window.location.href);
    (window as any).$cookies.set(
      consts.currentLearnerTeam,
      team,
      null,
      "/",
      domain
    );
  }

  private assignInitAssessment() {
    this.localDoneInitAssessment = this.doneInitAssessment;
  }

  @Watch("activeTab")
  private setURL() {
    if (this.activeTab === "") {
      console.log("asd");
      return;
    }
    this.assignInitAssessment();
    if (this.$route.query.tab === this.activeTab) {
      return;
    }
    this.$router.replace({
      name: "learnerhome",
      query: { tab: this.activeTab },
    });
  }
  private mounted() {
    const param = this.$route.query.tab;
    console.log(param);
    if (param in Tabs) {
      this.activeTab = param as string;
    } else {
      this.activeTab = "library";
    }
  }
}
